'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var key = require('interface-datastore/key');

var shardReadme = require('./shard-readme.js');

var PREFIX = '/repo/flatfs/shard/';
var SHARDING_FN = 'SHARDING';
var README_FN = '_README';

var ShardBase = /*#__PURE__*/function () {
  function ShardBase(param) {
    _classCallCheck(this, ShardBase);

    this.param = param;
    this.name = 'base';
    this._padding = '';
  }

  _createClass(ShardBase, [{
    key: "fun",
    value: function fun(s) {
      return 'implement me';
    }
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(PREFIX, "v1/").concat(this.name, "/").concat(this.param);
    }
  }]);

  return ShardBase;
}();

var Prefix = /*#__PURE__*/function (_ShardBase) {
  _inherits(Prefix, _ShardBase);

  var _super = _createSuper(Prefix);

  function Prefix(prefixLen) {
    var _this;

    _classCallCheck(this, Prefix);

    _this = _super.call(this, prefixLen);
    _this._padding = ''.padStart(prefixLen, '_');
    _this.name = 'prefix';
    return _this;
  }

  _createClass(Prefix, [{
    key: "fun",
    value: function fun(noslash) {
      return (noslash + this._padding).slice(0, this.param);
    }
  }]);

  return Prefix;
}(ShardBase);

var Suffix = /*#__PURE__*/function (_ShardBase2) {
  _inherits(Suffix, _ShardBase2);

  var _super2 = _createSuper(Suffix);

  function Suffix(suffixLen) {
    var _this2;

    _classCallCheck(this, Suffix);

    _this2 = _super2.call(this, suffixLen);
    _this2._padding = ''.padStart(suffixLen, '_');
    _this2.name = 'suffix';
    return _this2;
  }

  _createClass(Suffix, [{
    key: "fun",
    value: function fun(noslash) {
      var s = this._padding + noslash;
      return s.slice(s.length - this.param);
    }
  }]);

  return Suffix;
}(ShardBase);

var NextToLast = /*#__PURE__*/function (_ShardBase3) {
  _inherits(NextToLast, _ShardBase3);

  var _super3 = _createSuper(NextToLast);

  function NextToLast(suffixLen) {
    var _this3;

    _classCallCheck(this, NextToLast);

    _this3 = _super3.call(this, suffixLen);
    _this3._padding = ''.padStart(suffixLen + 1, '_');
    _this3.name = 'next-to-last';
    return _this3;
  }

  _createClass(NextToLast, [{
    key: "fun",
    value: function fun(noslash) {
      var s = this._padding + noslash;
      var offset = s.length - this.param - 1;
      return s.slice(offset, offset + this.param);
    }
  }]);

  return NextToLast;
}(ShardBase);

function parseShardFun(str) {
  str = str.trim();

  if (str.length === 0) {
    throw new Error('empty shard string');
  }

  if (!str.startsWith(PREFIX)) {
    throw new Error("invalid or no path prefix: ".concat(str));
  }

  var parts = str.slice(PREFIX.length).split('/');
  var version = parts[0];

  if (version !== 'v1') {
    throw new Error("expect 'v1' version, got '".concat(version, "'"));
  }

  var name = parts[1];

  if (!parts[2]) {
    throw new Error('missing param');
  }

  var param = parseInt(parts[2], 10);

  switch (name) {
    case 'prefix':
      return new Prefix(param);

    case 'suffix':
      return new Suffix(param);

    case 'next-to-last':
      return new NextToLast(param);

    default:
      throw new Error("unkown sharding function: ".concat(name));
  }
}

var readShardFun = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, store) {
    var key$1, get, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            key$1 = new key.Key(path).child(new key.Key(SHARDING_FN));
            get = typeof store.getRaw === 'function' ? store.getRaw.bind(store) : store.get.bind(store);
            _context.next = 4;
            return get(key$1);

          case 4:
            res = _context.sent;
            return _context.abrupt("return", parseShardFun(new TextDecoder().decode(res || '').trim()));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function readShardFun(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.readme = shardReadme;
exports.NextToLast = NextToLast;
exports.PREFIX = PREFIX;
exports.Prefix = Prefix;
exports.README_FN = README_FN;
exports.SHARDING_FN = SHARDING_FN;
exports.ShardBase = ShardBase;
exports.Suffix = Suffix;
exports.parseShardFun = parseShardFun;
exports.readShardFun = readShardFun;